import PropTypes from 'prop-types';
import SortOption from '../entities/sortOption';

export default PropTypes.shape( {
	label: PropTypes.string,
	options: PropTypes.arrayOf(
		PropTypes.instanceOf( SortOption )
	)
} );
